<div class="main-wrapper py-4 px-3">
  <!-- Hero Section -->
  <div class="row m-0 justify-content-center text-center mb-5">
    <div class="col-md-9 mt-4">
      <h1 class="mat-display-3 font-weight-bold mb-3 main-hero-title">Empower your brand, Ignite your success</h1>
      <p class="mat-title text-muted hero-subtitle mx-auto">
        Empowering your online presence for unparalleled success! Unlock the full potential of your brand with our innovative marketing and advertising solutions.
      </p>
    </div>
    
    <!-- Modern Search Pill -->
    <div class="col-md-8 mt-4">
      <form [formGroup]="searchCategoryForm" (ngSubmit)="search()">
        <div class="search-pill-container">
          <fa-icon [icon]="faSearch" class="text-muted mr-3" size="lg"></fa-icon>
          <input 
            placeholder="Search businesses, services or categories..." 
            class="searchInput flex-1 border-0" 
            name="searchPhrase" 
            formControlName="searchPhrase"
          />
          <button type="submit" mat-flat-button color="primary" class="search-btn text-white">
            SEARCH
          </button>
        </div>
      </form>
      
      <div class="d-flex justify-content-center p-3 align-items-center" *ngIf="searchPhrase">
        <p class="text-muted m-0"> Showing results for "{{searchPhrase}}" </p>
        <button type="button" (click)="clearSearch()" mat-stroked-button class="ml-3 rounded-pill">
          Clear Search
        </button>
      </div>
    </div>
  </div>

  <!-- Two CTA Cards (Find & Be Seen) -->
  <div class="row m-0 justify-content-center mb-5 gap-3 px-md-4">
    <div class="col-md-5 mb-4">
      <div class="modern-card p-4 h-100 d-flex flex-column justify-content-between">
        <div>
          <span class="pill-tag mb-3">For Users</span>
          <h2 class="font-weight-bold mb-2">Find. Follow. Connect.</h2>
          <p class="text-muted">Discover top-rated local services, follow your favorite brands, and communicate instantly—all in one place, entirely for free.</p>
        </div>
        <button mat-flat-button color="primary" class="rounded-pill w-100 py-3 mt-4 vibe-btn font-weight-bold text-white bg-primary" (click)="goTo('register')">
          Vibe For Free
        </button>
      </div>
    </div>
    
    <div class="col-md-5 mb-4">
      <div class="modern-card p-4 h-100 d-flex flex-column justify-content-between">
        <div>
          <span class="pill-tag mb-3 gold">For Businesses</span>
          <h2 class="font-weight-bold mb-2">Be Seen. Grow. Succeed.</h2>
          <p class="text-muted">Get your business in front of thousands of local searchers. Showcase your services, receive bookings, and build trust in your community.</p>
        </div>
        <button mat-flat-button color="accent" class="rounded-pill w-100 py-3 mt-4 list-btn font-weight-bold text-white bg-secondary" (click)="goTo('register')">
          List My Business
        </button>
      </div>
    </div>
  </div>

  <!-- Top Categories Section (From Mock 1) -->
  <div class="row m-0 justify-content-center mb-5 text-center px-md-4" *ngIf="!searchResult">
    <div class="col-md-10">
      <div class="d-flex justify-content-between align-items-center mb-4">
        <h2 class="m-0 font-weight-bold section-title">Top Categories</h2>
        <a class="link text-primary font-weight-bold" (click)="goTo('categories')">See All</a>
      </div>
      <div class="row m-0 justify-content-center">
        <div class="col-4 col-sm-2 mb-4 d-flex flex-column align-items-center link" (click)="goTo('categories')">
          <div class="category-circle bg-orange-light"><mat-icon>directions_car</mat-icon></div>
          <span class="category-label mt-2">Automotive</span>
        </div>
        <div class="col-4 col-sm-2 mb-4 d-flex flex-column align-items-center link" (click)="goTo('categories')">
          <div class="category-circle bg-green-light"><mat-icon>home</mat-icon></div>
          <span class="category-label mt-2">Property</span>
        </div>
        <div class="col-4 col-sm-2 mb-4 d-flex flex-column align-items-center link" (click)="goTo('categories')">
          <div class="category-circle bg-pink-light"><mat-icon>face</mat-icon></div>
          <span class="category-label mt-2">Beauty</span>
        </div>
        <div class="col-4 col-sm-2 mb-4 d-flex flex-column align-items-center link" (click)="goTo('categories')">
          <div class="category-circle bg-blue-light"><mat-icon>build</mat-icon></div>
          <span class="category-label mt-2">Engineering</span>
        </div>
        <div class="col-4 col-sm-2 mb-4 d-flex flex-column align-items-center link" (click)="goTo('categories')">
          <div class="category-circle bg-red-light"><mat-icon>restaurant</mat-icon></div>
          <span class="category-label mt-2">Restaurants</span>
        </div>
        <div class="col-4 col-sm-2 mb-4 d-flex flex-column align-items-center link" (click)="goTo('categories')">
          <div class="category-circle bg-grey-light"><mat-icon>more_horiz</mat-icon></div>
          <span class="category-label mt-2">More</span>
        </div>
      </div>
    </div>
  </div>

  <!-- Browse Categories & Category Lists -->
  <div class="row m-0 justify-content-center py-5 bg-white-rounded-section px-md-4">
    <div class="col-md-10 text-center mb-5">
      <h2 class="mat-display-2 font-weight-bold m-0 text-dark">The Unrivalled Platform</h2>
      <p class="text-muted">Your Exclusive Gateway to Visibility and Discovery!</p>
    </div>

    <!-- Skeleton Loaders -->
    <div *ngIf="!categories || categories.length < 1" class="row w-100 justify-content-center m-0">
      <div class="col-md-4 mb-4 col-sm-6 col-xs-12 p-3" *ngFor="let item of [1,2,3,4,5,6]">
        <app-ghost-rect></app-ghost-rect>
      </div>
    </div>

    <div class="row w-100 justify-content-center m-0" *ngIf="categories && categories.length > 0">
      <!-- Browse Categories Card -->
      <div class="col-md-4 mb-4 col-sm-6 col-xs-12 p-2" *ngIf="!searchResult">
        <div (click)="goTo('categories')" class="browse-all-categories-card h-100 w-100 d-flex flex-column justify-content-between p-4 link">
          <div>
            <h4 class="text-white mat-display-1 font-weight-bold mb-2">Browse All Categories</h4>
            <p class="text-white-50">Explore over {{categoryCount || 10}} business categories on the platform.</p>
          </div>
          <div class="d-flex justify-content-between align-items-center text-white font-weight-bold mt-4">
            <span>Explore</span>
            <fa-icon [icon]="faSearch" size="lg"></fa-icon>
          </div>
        </div>
      </div>

      <!-- Categories Grid -->
      <ng-container *ngIf="!searchResult">
        <div *ngFor="let category of categories" class="col-md-4 mb-4 col-sm-6 col-xs-12 p-2">
          <app-flip-card (emitFollow)="goTo('login')" (emitOpen)="open($event)" [category]="category"></app-flip-card>
        </div>
      </ng-container>

      <ng-container *ngIf="searchResult">
        <div *ngFor="let category of searchResult" class="col-md-4 mb-4 col-sm-6 col-xs-12 p-2">
          <app-flip-card (emitFollow)="goTo('login')" (emitOpen)="open($event)" [category]="category"></app-flip-card>
        </div>
      </ng-container>
    </div>

    <div class="col-md-10 mt-5 text-center">
      <h3 class="mat-display-1 font-weight-bold mb-2 text-dark">Stay ahead of the curve with our data-driven strategies.</h3>
      <p class="text-muted mx-auto" style="max-width: 600px;">
        The ADVIBE network is growing daily, bringing you trusted businesses across a wide variety of local industries.
      </p>
    </div>
  </div>

  <!-- Bottom CTA / Feedback Section -->
  <div class="row m-0 justify-content-center py-5 text-white bg-dark-modern rounded-section mt-5 px-md-4">
    <div class="col-md-10 d-flex flex-column flex-md-row align-items-center justify-content-between text-center text-md-left">
      <div class="d-flex align-items-center flex-column flex-md-row mb-4 mb-md-0">
        <div class="feedback-icon-box bg-primary p-3 rounded-circle mr-md-4 mb-3 mb-md-0">
          <fa-icon size="3x" class="text-white" [icon]="faShake"></fa-icon>
        </div>
        <div>
          <h2 class="m-0 font-weight-bold text-white">ADVIBE is including everyone</h2>
          <p class="text-white-50 m-0 mt-1" style="max-width: 500px;">
            No matter what the size of your business is, you deserve a platform to showcase your brand and connect with a trusted network.
          </p>
        </div>
      </div>
      <div class="d-flex flex-column align-items-center">
        <span class="text-white-50 mb-2">Have a feature request?</span>
        <button routerLink="/contact" mat-raised-button color="primary" class="px-4 py-2 font-weight-bold">
          Give Feedback
        </button>
      </div>
    </div>
  </div>
</div>
